import componentsList from '@/config/components-list-v1.js'

export default {
  namespaced: true,
  state: {
    list: componentsList
  },
  getters: {
    componentsList: state => state.list,
    getComponentByName: state => name => state.list.find(comp => comp.name === name)
  }
}

//group
// -1 - ungrouped
// 0 - text
// 1 - background
// 2 - button
// 3 - icon
// 4 - input
// 5 - image
// 6 - header
// 7 - footer
// 8 - navigation
// 9 - overlay
// 10 - card
// 11 - list
// 12 - menu
// 13 - form
// 14 - slider
// 15 - modal

//tag 
// 0 - text
// 1 - img
// 2 - button
// 3 - input
// 4 - icon (i)
// 5 - video
// 6 - audio
// 7 - link
// 8 - container
// 9 - list
// 10 - list-item
// 11 - form
// 12 - checkbox
// 13 - radio
// 14 - slider
// 15 - progressbar
// 16 - dropdown
// 17 - toggle
// 18 - canvas
// 19 - map
// 20 - divider

//position
// 0 - middle
// 1 - top
// 2 - bottom
// 3 - left
// 4 - right
// 5 - top-left
// 6 - top-right
// 7 - bottom-left
// 8 - bottom-right
// 9 - center-top
// 10 - center-bottom
// 11 - center-left
// 12 - center-right


//flex
//flex-direction
// 0 - row (слева направо)
// 1 - row-reverse (справа налево)
// 2 - column (сверху вниз)
// 3 - column-reverse (снизу вверх)

//justify-content
// 0 - flex-start (в начале контейнера)
// 1 - flex-end (в конце контейнера)
// 2 - center (по центру)
// 3 - space-between (равномерно, первый и последний у краёв)
// 4 - space-around (равномерно, с равным отступом по краям)
// 5 - space-evenly (равномерно, с одинаковым отступом между элементами)

//align-items
// 0 - stretch (растянуть)
// 1 - flex-start (у начала контейнера)
// 2 - flex-end (у конца контейнера)
// 3 - center (по центру)
// 4 - baseline (по базовой линии)

//flex-wrap
// 0 - nowrap (без переноса)
// 1 - wrap (перенос на новую строку)
// 2 - wrap-reverse (перенос в обратном порядке)


//width
// 0 - auto (автоматическая ширина)
// 1 - 100% (полная ширина)
// 2 - 50% (половина ширины)
// 3 - 25% (четверть ширины)
// 4 - 75% (три четверти ширины)
// 5 - 20% (одна пятая ширины)
// 6 - 33.333% (одна треть ширины)
// 7 - 66.666% (две трети ширины)
// 8 - 100vw (на всю ширину viewport)
// 9 - 50vw (половина ширины viewport)
// 10 - fit-content (по содержимому)
// 11 - min-content (минимальная ширина по содержимому)
// 12 - max-content (максимальная ширина по содержимому)
// 13 - 320px (фиксированная ширина для мобильных)
// 14 - 768px (фиксированная ширина для планшетов)
// 15 - 1024px (фиксированная ширина для десктопов)
// 16 - 100px (малая фиксированная ширина)
// 17 - 200px (средняя фиксированная ширина)
// 18 - 300px (большая фиксированная ширина)
// 19 - 400px (очень большая фиксированная ширина)
// 20 - 50px
// 21 - 90%

//height
// 0 - auto (автоматическая ширина)
// 1 - 100% (полная ширина)
// 2 - 50% (половина ширины)
// 3 - 25% (четверть ширины)
// 4 - 75% (три четверти ширины)
// 5 - 20% (одна пятая ширины)
// 6 - 33.333% (одна треть ширины)
// 7 - 66.666% (две трети ширины)
// 8 - 100vw (на всю ширину viewport)
// 9 - 50vw (половина ширины viewport)
// 10 - fit-content (по содержимому)
// 11 - min-content (минимальная ширина по содержимому)
// 12 - max-content (максимальная ширина по содержимому)
// 13 - 320px (фиксированная ширина для мобильных)
// 14 - 768px (фиксированная ширина для планшетов)
// 15 - 1024px (фиксированная ширина для десктопов)
// 16 - 100px (малая фиксированная ширина)
// 17 - 200px (средняя фиксированная ширина)
// 18 - 300px (большая фиксированная ширина)
// 19 - 400px (очень большая фиксированная ширина)
// 20 - 50px
// 21 - 90%